module.exports = __webpack_public_path__ + "img/close-upload-icon.e03fd25b.svg";